// extracted by mini-css-extract-plugin
module.exports = {"title":"feature-description-module--title--27xyz","description":"feature-description-module--description--1xBIs"};